import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import Eleve from './eleve';
import ParentEleveNotification from './eleve-notification-modal';
import EleveDeleteModal from './eleve-delete-modal';
import EleveDetail from './eleve-details';
import EleveUpdate from './eleve-update';
import EleveUpdatePaiement from './eleve-paiement-modal';
import EleveFactureModal from './eleve-send-facture-modal';
import FicheEleve from './fiche-eleve';
import FicheEleveDetail from './fiche-eleve-details';
import EleveUnlinkSupportModal from './eleve-unlink-support';
import DispensesCours from './dispenses-cours';
import DispensesCoursDetail from './dispenses-cours-detail';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/new`} component={EleveUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/edit`} component={EleveUpdate} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:id/details`} exact component={FicheEleveDetail} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid`} exact component={FicheEleve} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:anneeScolaireId/:id/details`} exact component={EleveDetail} />
      <ErrorBoundaryRoute
        path={`${match.url}/:ecoleid/:anneeScolaireId/dispenses/:classeId/:matiereId/details`}
        exact
        component={DispensesCoursDetail}
      />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:anneeScolaireId/dispenses`} exact component={DispensesCours} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:anneeScolaireId`} exact component={Eleve} />
    </Switch>
    <ErrorBoundaryRoute
      path={`${match.url}/:ecoleid/:anneeScolaireId/:id/details/dissociate-support`}
      component={EleveUnlinkSupportModal}
    />
    <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:anneeScolaireId/:id/details/update-paiement`} component={EleveUpdatePaiement} />
    <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:anneeScolaireId/:id/details/send-facture`} component={EleveFactureModal} />
    <ErrorBoundaryRoute exact path={`${match.url}/:id/notification`} component={ParentEleveNotification} />
    <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:id/delete`} component={EleveDeleteModal} />
  </>
);

export default Routes;
